var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"settings-page"}},[(this.userType === 'artist')?_c('SettingsUser',{staticClass:"c-max-w"}):(this.userType === 'label')?_c('SettingsLabel',{staticClass:"c-max-w"}):_c('Loader',{staticClass:"pos-center"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }